import React from 'react';
import uuidv4 from 'uuid';

import { getData, postData } from '../../../dataLib';

import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import AddBoxIcon from '@material-ui/icons/AddBox';

//comopnents:
import NeuriteGrid from '../../neurite_grid';
import DatePicker from '../../utils/DatePicker';


const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: 700,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        minWidth: 120,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px',
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
    formComent: {
        display: 'flex',
        justifyContent: 'center',
        margin: '10px 0 5px 25px',
        width: 520,
        minWidth: 120,
    },
    spinnerContainer: {
        width: "100%"
    }
});

class EditInventario extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showSpinner: false,
            a_fInventario: this.props.inventario.fInventario.slice(0, 10),
            inventario: this.props.inventario,
            primeroAbierto: this.props.primeroAbierto,
            ultimoCerrado: this.props.ultimoCerrado,
        };
        // añade un atributo para poner grayed las columnas que no deben modificarse
        this.state.inventario.lLineas = this.props.inventario.lLineas.map(p => {
            return { ...p, colColorTrue: true };
        });
    }

    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };
    handleValueChangeDate = (event, field) => {

        this.setState({ ...this.state, [field]: event });
    };



    guarda_Inventario = () => {
        this.setState(
            {
                ...this.state,
                inventario: {
                    ...this.state.inventario,
                    fValidado: new Date().toISOString().slice(0, 10),
                    fInventario: this.state.a_fInventario,
                },
                showSpinner: true,
            },
            () => {
                this.props.okHandler(this.state.inventario);
                this.props.hideDialog();
            },
        );
    };

    refreshInventario = inventarioId => {
        getData(
            'DCInventarios/' + inventarioId,
            response => {
                this.setState({ ...this.state, inventario: response.data, showSpinner: false });
            },
            error => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'ERROR fetching inventario',
                    },
                    'acc_inventario',
                    false,
                    'sm',
                );
                this.setState({ ...this.state, showSpinner: false });
            },
            this.props.user,
        );
    }

    onClickAddLineInventario = () => {
        this.props.openDialog(
            'ListArticulos',
            {
                acceptHandler: articulo => {
                    this.setState({ ...this.state, showSpinner: true });
                    postData(
                        `DCInventarios/nuevo_articulo?inventario_id=${this.state.inventario.id}&articulo_centro_compra_id=${articulo.idArticuloCompraCentro}&usuario_id=${this.state.inventario.usuarioId}`,
                        response => {
                            this.refreshInventario(this.state.inventario.id);
                        },
                        e => {
                            this.setState({ ...this.state, showSpinner: false });
                            this.props.openDialog(
                                'SimpleMessage',
                                {
                                    message: 'ERROR ' + e.response.data,
                                },
                                uuidv4(),
                                false,
                                'sm',
                            );
                        },
                        {},
                        this.props.user,
                    );
                },
            },
            uuidv4(),
            true,
            'md',
        );
    }

    handleGridRowsUpdated = ({ fromRow, toRow, fromRowData, updated }) => {
        if (parseInt(fromRow) !== parseInt(toRow)) return; //solo modificamos una fila

        // const nuevaLista = this.state.inventario.lLineas.slice();
        // for (let i = fromRow; i <= toRow; i++) {
        //     let updatedRow = update(this.state.inventario.lLineas[i], {
        //         $merge: updated,
        //     });
        //     nuevaLista[i] = updatedRow;
        // }

        const nuevaLista = this.state.inventario.lLineas.slice();

        let updatedRow = update(this.state.inventario.lLineas[fromRowData.grid_index], {
            $merge: updated,
        });
        nuevaLista[fromRowData.grid_index] = updatedRow;

        this.setState({
            ...this.state,
            inventario: { ...this.state.inventario, lLineas: nuevaLista },
        });
    };

    cierraInventario = () => {
        this.props.openDialog(
            'ConfirmationDialog',
            {
                message:
                    '¿Desea cerrar el inventario de ' +
                    this.state.inventario.fInventario.slice(0, 10) +
                    ' ?',
                acceptHandler: () => {
                    this.setState(
                        {
                            ...this.state,
                            inventario: {
                                ...this.state.inventario,
                                bCerrado: true,
                                fCerrado: new Date().toISOString().slice(0, 10),
                                cerradoUsuarioId: this.props.user.profile.sub,
                            },
                            showSpinner: true,
                        },
                        () => {
                            this.props.cierraInventarioHandler(
                                this.state.inventario,
                            );
                            this.props.hideDialog();
                        },
                    );
                },
            },
            uuidv4(),
            false,
            'sm',
        );
    };

    abreInventario = () => {
        this.props.openDialog(
            'ConfirmationDialog',
            {
                message:
                    '¿Desea abrir el inventario de ' +
                    this.state.inventario.fInventario.slice(0, 10) +
                    ' ?',
                acceptHandler: () => {
                    this.setState(
                        {
                            ...this.state,
                            inventario: {
                                ...this.state.inventario,
                                bCerrado: false,
                                fCerrado: {},
                                cerradoUsuarioId: this.props.user.profile.sub,
                            },
                            showSpinner: true,
                        },
                        () => {
                            this.props.abreInventarioHandler(
                                this.state.inventario,
                            );
                            this.props.hideDialog();
                        },
                    );
                },
            },
            uuidv4(),
            false,
            'sm',
        );
    };

    muestraFechaInventario = () => {
        const { classes } = this.props;

        if (
            this.state.inventario.fValidado ||
            this.state.inventario.bCerrado === true
        ) {
            return (
                <div className={classes.containerPair}>
                    <Typography
                        variant="body1"
                        className={classes.title}
                        color={'secondary'}
                    >
                        {'Fecha Inventario: ' + new Date(this.props.inventario.fInventario.slice(0, 10)).toLocaleDateString("es-ES", { year: "numeric", month: "2-digit", day: "2-digit" })}
                    </Typography>
                </div>
            );
        } else {
            return (
                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        {/* <TextField
                            id={'fInventario'}
                            label={'Fecha Inventario'}
                            placeholder={'Fecha Inventario'}
                            type="date2"
                            value={this.state.a_fInventario}
                            onChange={(event) => this.handleValueChange(event, 'a_fInventario')}
                        /> */}
                        <DatePicker
                            label={'Fecha Inventario'}
                            value={this.state.a_fInventario}
                            onChange={event => {
                                if (event && !isNaN(event)) {
                                    const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                    this.handleValueChangeDate(
                                        d.toISOString().slice(0, 10),
                                        'a_fInventario',
                                    )
                                }
                            }}
                        />
                    </FormControl>
                </div>
            );
        }
    };

    botoneraValidacionCierre = () => {
        const { classes } = this.props;

        if ([0, 4, 5, 14, 15, 17, 18].includes(this.props.iPerfil)) {
            if (this.state.inventario.bCerrado === false) {
                if (this.state.primeroAbierto) {
                    return (
                        <div className={classes.buttonsContainer}>
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.props.hideDialog()}
                            >
                                Atrás
                            </Button>
                            <Button
                                hidden={this.props.iPerfil === 17}
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.guarda_Inventario()}
                            >
                                Guardar
                            </Button>
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.cierraInventario()}
                            >
                                Cerrar Inventario
                            </Button>
                        </div>
                    );
                } else {
                    return (
                        <div className={classes.buttonsContainer}>
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.props.hideDialog()}
                            >
                                Atrás
                            </Button>
                        </div>
                    );
                }
            } else {
                if (this.state.ultimoCerrado) {
                    return (
                        <div className={classes.buttonsContainer}>
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.props.hideDialog()}
                            >
                                Atrás
                            </Button>
                            <Button
                                hidden={![0, 17, 18].includes(this.props.iPerfil)}
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="primary"
                                onClick={() => this.abreInventario()}
                            >
                                Abrir Inventario
                            </Button>
                        </div>
                    );
                } else {
                    return (
                        <div className={classes.buttonsContainer}>
                            <Button
                                className={classes.buttonsBottom}
                                variant="contained"
                                color="secondary"
                                onClick={() => this.props.hideDialog()}
                            >
                                Atrás
                            </Button>
                        </div>
                    );
                }
            }
        } else {
            if (this.state.inventario.bCerrado === true) {
                return (
                    <div className={classes.buttonsContainer}>
                        <Button
                            className={classes.buttonsBottom}
                            variant="contained"
                            color="secondary"
                            onClick={() => this.props.hideDialog()}
                        >
                            Atrás
                        </Button>
                    </div>
                );
            } else {
                return (
                    <div className={classes.buttonsContainer}>
                        <Button
                            className={classes.buttonsBottom}
                            variant="contained"
                            color="secondary"
                            onClick={() => this.props.hideDialog()}
                        >
                            Atrás
                        </Button>
                        <Button
                            className={classes.buttonsBottom}
                            variant="contained"
                            color="primary"
                            onClick={() => this.guarda_Inventario()}
                        >
                            Guardar
                        </Button>
                    </div>
                );
            }
        }
    };

    render() {
        const { classes } = this.props;

        if (this.state.showSpinner === true)
            return (
                <Grid
                    container
                    direction="row"
                    justify="center"
                    alignItems="center"
                >
                    <CircularProgress
                        className={classes.spinner}
                        color="primary"
                    />
                </Grid>
            );
        else {
            return (
                <div className={classes.root}>
                    <div>{this.muestraFechaInventario()}</div>

                    <div style={{ marginBottom: 20 }}>
                        {this.state.inventario &&
                            this.state.inventario.lLineas ? (
                                <React.Fragment>
                                    <IconButton color="primary" aria-label="addinv" component="span" style={{ position: "absolute", left: "40px" }}
                                        onClick={() => { this.onClickAddLineInventario() }}>
                                        <AddBoxIcon />
                                    </IconButton>
                                    <NeuriteGrid
                                        id="e_i"
                                        enableFilter={true}
                                        tabulation={true}
                                        columns={[
                                            {
                                                key: 'articuloCompraDescr',
                                                name: 'Artículo',
                                                editable: false,
                                                dragable: false,
                                                width: 350,
                                                grayField: 'colColorTrue',
                                            },
                                            {
                                                key: 'articuloCompraCodBarras',
                                                name: 'Cod. Barras',
                                                editable: false,
                                                dragable: false,
                                                width: 150,
                                                grayField: 'colColorTrue',
                                            },
                                            {
                                                key: 'iDestDescr',
                                                name: 'Origen',
                                                editable: false,
                                                dragable: false,
                                                width: 100,
                                                grayField: 'colColorTrue',
                                            },
                                            /* {
                                                key: 'stockPrev',
                                                name: (
                                                    <span title="Stock del inventario anterior">
                                                        Stock ant.
                                                </span>
                                                ),
                                                editable: false,
                                                dragable: false,
                                                type: 'int',
                                                width: 70,
                                                grayField: 'colColorTrue',
                                            },
                                            {
                                                key: 'stock',
                                                name: (
                                                    <span title="Stock del inventario actual">
                                                        Stock
                                                </span>
                                                ),
                                                editable: false,
                                                dragable: false,
                                                type: 'int',
                                                width: 70,
                                                grayField: 'colColorTrue',
                                            }, */
                                            {
                                                key: 'unidades',
                                                name: 'Unidades',
                                                tooltip: 'Unidades inventariadas',
                                                editable: this.state.ultimoCerrado ? false : true,
                                                dragable: false,
                                                type: 'int',
                                                width: 70,
                                            },
                                            /* {
                                                key: 'maquinaDescr',
                                                name: 'Máquina',
                                                editable: false,
                                                dragable: false,
                                                width: 200,
                                                grayField: 'colColorTrue',
                                            }, */
                                        ]}
                                        rows={this.state.inventario.lLineas}
                                        height={300}
                                        buttonEdit={false}
                                        buttonDelete={false}
                                        buttonNew={false}
                                        onRowsUpdated={this.handleGridRowsUpdated}
                                    />
                                </React.Fragment>
                            ) : (
                                ''
                            )}
                    </div>

                    {this.botoneraValidacionCierre()}
                </div>
            );
        }
    }
}

EditInventario.propTypes = {
    inventario: PropTypes.object.isRequired,
    okHandler: PropTypes.func.isRequired,
    cierraInventarioHandler: PropTypes.func.isRequired,
    abreInventarioHandler: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    iPerfil: PropTypes.number.isRequired,
    ultimoCerrado: PropTypes.bool.isRequired,
    primeroAbierto: PropTypes.bool.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditInventario);
